import type { MarketRentAddress } from "api/landlord/market-rent";

export const MARKET_RENT_SUBJECTS_QUERY_KEY = "MARKET_RENT_SUBJECTS";
export const MARKET_RENT_REPORT_QUERY_KEY = "MARKET_RENT_REPORT";
export const MARKET_RENT_COMPS_QUERY_KEY = "MARKET_RENT_COMPS";

export const US_STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
] as const;

export const formatAddress = (address?: MarketRentAddress | null): string => {
  if (!address) return "";
  return [
    address.address1,
    address.city,
    [address.state_or_province, address.postal_code].filter(Boolean).join(" ")
  ]
    .filter(Boolean)
    .join(", ");
};

/**
 * Whole-dollar money for table cells and headline figures. Cents are noise at
 * rent scale and the design never shows them.
 */
export const formatMoney = (cents?: number | null): string => {
  if (cents === null || cents === undefined) return "—";
  return `$${Math.round(cents / 100).toLocaleString("en-US")}`;
};

export const formatNumber = (value?: number | null): string => {
  if (value === null || value === undefined) return "—";
  return value.toLocaleString("en-US");
};

/** Trims a trailing ".0" so 2 baths reads "2" and 2.5 stays "2.5". */
export const formatDecimal = (value?: number | null): string => {
  if (value === null || value === undefined) return "—";
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
};
